// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import initMarquee from "./marquee";
import flyerForm from "./flyerForm";
import leadForm from "./leadForm";

// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
initMarquee();
flyerForm();
leadForm();
